class Hospital {
  constructor(title, address, phoneNumber, latitude, longitude, cityId, hospitalDiagnosisIds, sepasCode) {
    this.title = title;
    this.address = address;
    this.phoneNumber = phoneNumber;
    this.latitude = latitude;
    this.longitude = longitude;
    this.cityId = cityId;
    this.hospitalDiagnosisIds = hospitalDiagnosisIds;
    this.sepasCode = sepasCode;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      confimType: '',
      hospitalId: null,
      searchTitle: '',
      disabelConfirm: false,
      addFlag: false,
      modalTitle: '',
      showAddEditModal: false,
      searchModal: false,
      isSearch: false,

      modalIcon: '',
      provinceTitle: '',
      polyganData: null,
      hospitalManagmentInformationTableHeaders: [
        { text: 'ردیف', value: 'counter', align: 'center' },
        { text: 'نام بیمارستان', value: 'title', align: 'center' },
        { text: 'شهرستان', value: 'city', align: 'center' },
        { text: 'شماره تلفن', value: 'phoneNumber', align: 'center' },
        { text: 'آدرس', value: 'address', align: 'center' },
        { text: 'سانتر', value: 'diagno', align: 'center' },
        { text: 'عملیات', value: 'actions', sortable: false, align: 'center' },
      ],
      searchCityId: null,
      searchText: '',
      hospitalphoneNumbers: [],
      //diagnoses
      diagnosisBaseDataModal: false,
      allHospitalSelectedDiagnosisBaseDatas: [],
      allHospitalDiagnosisBaseDatas: [],
    };
  },
  methods: {
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        this.modalTitle = 'افزودن بیمارستان';
        this.modalIcon = 'mdi-plus';
        this.addFlag = true;
        this.confimType = 'add';
        this.showAddEditModal = true;
        this.getAllDiagnosisBaseDatas();
      } else if (type == 2) {
        this.modalTitle = 'ویرایش بیمارستان';
        this.modalIcon = 'mdi-pencil';
        this.confimType = 'edit';
        this.addFlag = false;
        this.getHospitalFunction(id);
        this.showAddEditModal = true;
      }
    },
    cancelAddEditFunction: function () {
      this.hospital = new Hospital('', '', '', null, null, null, [], '');
      this.position = null;
      this.hospitalphoneNumbers = [];
      this.showAddEditModal = false;
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'add') {
        this.addHospitalFunction();
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.title = 'ویرایش بیمارستان';
        this.$refs.confirm.text = 'از ویرایش بیمارستان اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.title = 'حذف بیمارستان';
        this.$refs.confirm.text = 'از حذف بیمارستان اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'diagno') {
        this.$refs.confirm.title = 'ویراش سانتر';
        this.$refs.confirm.text = 'از ویرایش سانترهای بیمارستان اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'add') {
        this.disabelConfirm = true;
        this.addHospitalFunction();
      } else if (this.confimType == 'edit') {
        this.disabelConfirm = true;
        this.editHospitalFunction();
      } else if (this.confimType == 'delete') {
        this.disabelConfirm = true;
        this.deleteHospitalFunction();
      } else if (this.confimType == 'diagno') {
        this.disabelConfirm = true;
        this.EditHospitalDiagnosisBaseDataFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'add') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'diagno') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },

    //delete
    showDeleteConfirmFunction: function (id) {
      this.hospitalId = id;
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
    addPhoneNumber: function () {
      for (let i = 0; i < this.hospitalphoneNumbers.length; i++) {
        if (this.hospitalphoneNumbers[i].text == '') {
          return;
        }
      }
      this.hospitalphoneNumbers.push({
        text: '',
        id: this.hospitalphoneNumbers.length + 1,
      });
    },
    removePhoneNumber: function (id) {
      for (let i = 0; i < this.hospitalphoneNumbers.length; i++) {
        if (id == this.hospitalphoneNumbers[i].id) {
          this.hospitalphoneNumbers.splice(i, 1);
          break;
        }
      }
    },
    setProvinceForGetCityGeoLocation: function () {
      if (this.allProvincesForOther.length == 1) {
        this.provinceTitle = this.allProvincesForOther[0].title;
      }
    },
    getCityGeoLocation: function () {
      if (this.provinceTitle && this.hospital.cityId) {
        let cityName = '';
        for (let i = 0; i < this.allCitysForOther.length; i++) {
          if (this.hospital.cityId == this.allCitysForOther[i].id)
            cityName = this.allCitysForOther[i].title;
        }
        this.searchForLocation(cityName, this.provinceTitle);
      }
    },
    goToCity: function (data) {
      this.$refs.modalmap.mapObject.flyTo([data[0].lat, data[0].lon], 12);
    },
    // fence

    //search
    showSearchModal: function () {
      this.searchModal = true;
    },
    search: function () {
      this.page = 1;
      this.searchModal = false;
      this.isSearch = true;
      this.$refs.pagination.page = 1;
      this.getListOfHospitalsWithPagination();
    },
    removeFilters: function () {
      this.searchCityId = null;
      this.searchText = '';
      this.isSearch = false;
      this.page = 1;
      this.$refs.pagination.page = 1;
      this.getListOfHospitalsWithPagination();
    },
    cancelSearch: function () {
      this.searchCityId = null;
      this.searchText = '';
      this.searchModal = false;
    },
    //Diagnoses part
    showEditDiagnosisBaseDataModal: function (id) {
      this.hospitalId = id;
      this.allHospitalSelectedDiagnosisBaseDatas = [];
      this.allHospitalDiagnosisBaseDatas = [];
      this.getAllDiagnosisBaseDatas();
    },
    readyHospitalDiagnosisBaseData: function () {
      this.getHospitalDiagnosisBaseDataList();
    },
    defineHospitalDiagnosisBaseDatas: function () {
      if (this.allHospitalSelectedDiagnosisBaseDatas.length > 0) {
        for (let i = 0; i < this.allHospitalDiagnosisBaseDatas.length; i++) {
          for (let j = 0; j < this.allHospitalSelectedDiagnosisBaseDatas.length; j++) {
            if (
              this.allHospitalDiagnosisBaseDatas[i].id ===
              this.allHospitalSelectedDiagnosisBaseDatas[j].id
            ) {
              this.allHospitalDiagnosisBaseDatas.splice(i, 1);
              i--;
              break;
            }
          }
        }
      }
      this.diagnosisBaseDataModal = true;
    },
    addDiagnoToHospitalDiagnos: function (Diagno) {
      this.allHospitalSelectedDiagnosisBaseDatas.push(Diagno);
      for (let i = 0; i < this.allHospitalDiagnosisBaseDatas.length; i++) {
        if (Diagno.id == this.allHospitalDiagnosisBaseDatas[i].id) {
          this.allHospitalDiagnosisBaseDatas.splice(i, 1);
          break;
        }
      }
    },
    removeDiagnoFromHospitalDiagnos: function (Diagno) {
      this.allHospitalDiagnosisBaseDatas.push(Diagno);
      for (let i = 0; i < this.allHospitalSelectedDiagnosisBaseDatas.length; i++) {
        if (Diagno.id == this.allHospitalSelectedDiagnosisBaseDatas[i].id) {
          this.allHospitalSelectedDiagnosisBaseDatas.splice(i, 1);
          break;
        }
      }
    },
    setHospitalDiagno: function () {
      this.confimType = 'diagno';
      this.showConfirmDialogFunction();
    },
    cancleEditHospitalDiagno: function () {
      this.allHospitalSelectedDiagnosisBaseDatas = [];
      this.allHospitalDiagnosisBaseDatas = [];
      this.diagnosisBaseDataModal = false;
    },
  },
};
